export default __webpack_public_path__ + "static/media/pink-ok.0002ed21.svg";